export type SSORedirectParams = {
    ssoProvider: string;
};

export type SSOParams = {
    applicationId: string;
    universitySlug: string;
    successUrl: string;
    gatewayUrl: string;
    ssoProviders: string[];
};

/*  What get's called after when the redirect kicks in */
export type SSOHandleAuthCodeParams = {
    contextType: string;
    onSuccess(bearerToken: string): Promise<void> | void;
    onError(obj: {error: string}): void;
    code?: string;
    origin?: string;
};

export enum SSO_PROVIDER {
    GOOGLE = "google",
    APPLE = "apple",
}

export enum AUTH_TYPE {
    LOGIN = "login",
    SIGNUP = "signup",
}

export enum SSO_FLOWS {
    SOCIAL = "social",
    UNIVERSITY = "university",
}

/**
 *
 * Enum representing the status of Social Login Initialization for the app:
 * - UNKNOWN (default): The status of SSO initialization is not determined. It's unclear whether the app has invoked SSO initialization due to feature flag.
 * - READY: SSO initialization has been completed successfully.
 * - FAILED: SSO initialisation has failed.
 * - LOADING: SSO initialization is currently in progress.
 */
export enum SSO_INIT_STATUS {
    "UNKNOWN",
    "READY",
    "FAILED",
    "LOADING",
}
